import { FC, Fragment, useContext, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { SectionContentTest } from "./test";
import { UserProgramContext } from "../../context/user-program/user-program";
import { useParams } from "react-router-dom";
import { assertNonNullable } from "../../utils/asserts";
import { HandoutStep } from "./handout-step";
import { SectionStep } from "../../content/types";
import YouTube from "react-youtube";

export const SectionContent: FC<object> = () => {
  const { title: sectionTitle } = useParams();
  const [videoWatched, setVideoWatched] = useState<Array<string>>([]);
  const { program, dispatch } = useContext(UserProgramContext);

  assertNonNullable(program);

  const currentSection = program.sections.find(
    (section) => section.title === sectionTitle
  );

  assertNonNullable(currentSection);

  currentSection.steps
    .filter((step) => step.enabled)
    .sort((a, b) => a.order - b.order);

  const withHandout = typeof currentSection.handoutStepNumber === "number";

  const steps = [...currentSection.steps];

  if (withHandout) {
    steps.splice(currentSection.handoutStepNumber! - 1, 0, {} as SectionStep);
  }

  const getCurrentStepIndex = (steps: Array<SectionStep>): number => {
    const handoutStepEnabled =
      withHandout &&
      steps
        .slice(0, currentSection.handoutStepNumber)
        .every((step) => step.enabled && step.completedOn);

    if (
      withHandout &&
      handoutStepEnabled &&
      !currentSection.handoutStepPassed
    ) {
      // @ts-ignore-line
      return currentSection.handoutStepNumber;
    }

    const allPassed =
      steps
        .filter((step) => step.enabled)
        .every((step) => step.enabled && step.completedOn) &&
      currentSection.handoutStepPassed !== false;

    return allPassed
      ? -1
      : steps.findIndex((step) => step.enabled && !step.completedOn);
  };

  const currentStepIndex = getCurrentStepIndex(steps);

  const [currentlyOpenStep, setCurrentlyOpenStep] =
    useState<number>(currentStepIndex);

  if (!sectionTitle || !currentSection) {
    return null;
  }

  return (
    <Fragment>
      {sectionTitle}
      {steps.map((step, stepIndex) => {
        if (
          typeof currentSection.handoutStepNumber === "number" &&
          stepIndex + 1 === currentSection.handoutStepNumber
        ) {
          const handoutStepEnabled = currentSection.steps
            .slice(0, currentSection.handoutStepNumber - 1)
            .every((step) => step.enabled && step.completedOn);

          return (
            <HandoutStep
              handoutLink={currentSection.handoutLink!}
              disabled={!handoutStepEnabled}
              dispatch={dispatch}
              key={step.title + stepIndex}
              expanded={currentlyOpenStep === currentSection.handoutStepNumber}
              setCurrentlyOpenStep={setCurrentlyOpenStep}
              passed={!!currentSection.handoutStepPassed}
              sectionTitle={sectionTitle}
              stepIndex={currentSection.handoutStepNumber}
            />
          );
        }

        // @TODO - for now I leave this code here in case we change our mind
        // and want to show disabled steps again
        // if we are sure we never want to do this again - a more thorough change is required
        // to remove the step.enabled logic from the codebase including backend and database
        if (step.enabled === false) {
          return null;
          // return (
          //   <Accordion
          //     expanded={false}
          //     disabled
          //     sx={{ marginTop: "1em" }}
          //     key={stepIndex + 1}
          //   >
          //     <AccordionSummary>
          //       <Typography>{step.title}</Typography>
          //     </AccordionSummary>
          //   </Accordion>
          // );
        }

        return (
          <Accordion
            expanded={stepIndex === currentlyOpenStep}
            sx={{ marginTop: "1em" }}
            key={stepIndex + 1}
          >
            <AccordionSummary
              onClick={() =>
                setCurrentlyOpenStep((prev) =>
                  prev === stepIndex ? -1 : stepIndex
                )
              }
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={`step-${step}`}
            >
              {!!step.completedOn && (
                <CheckBoxIcon color="success" sx={{ marginRight: "0.5em" }} />
              )}
              <Typography>{step.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                direction="column"
                sx={{ maxWidth: "750px", margin: "auto" }}
              >
                <Grid item sx={{ height: "57%", width: "100%" }}>
                  <YouTube
                    videoId={step.youtubeVideoId}
                    id={step.youtubeVideoId}
                    style={{ width: "100%", aspectRatio: "16/9" }}
                    opts={{ width: "100%", height: "100%" }}
                    title={step.title}
                    onPlay={(e: any) => {
                      e.target.int = setInterval(() => {
                        const watched = e.target.getCurrentTime();
                        const duration = e.target.getDuration();

                        console.log(watched, duration);

                        if (watched / duration >= 0.9) {
                          setVideoWatched((prev) => [
                            ...prev,
                            step.youtubeVideoId,
                          ]);
                        }
                      }, 1000);
                    }}
                    onPause={(e: any) => {
                      e.target.int && clearInterval(e.target.int);
                    }}
                    onEnd={(e: any) => {
                      e.target.int && clearInterval(e.target.int);
                    }}
                  />
                </Grid>
                <Grid item>
                  <SectionContentTest
                    disabled={!videoWatched.includes(step.youtubeVideoId)}
                    stepId={step.id}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Fragment>
  );
};
